<!--
 * @Description: 子系统介绍 详情
 * @Author: PF
 * @Date: 2024-03-12 10:11:26.395
 * @LastEditors: PF
 * @LastEditTime: 2025-04-08 09:36:16
-->
<template>
  <div>
    <el-dialog class="wp70 hp90" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">帮助说明</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container class="xinwen" v-loading="loading" v-if="ruleForm.cdgnbzms">
        <el-header style="padding: 20px;border: 1px solid rgb(228, 231, 237);">
          <div class="card-header">
            <h2>{{ruleForm.zxtmc}} <span v-if="ruleForm.zxtmc&&ruleForm.cdmc">-</span> {{ruleForm.cdmc}}</h2>
          </div>
        </el-header>
        <el-main style="padding:20px; border: 1px solid #e4e7ed; border-top: none;overflow: auto;">
          <div class="nei-rong">
            <div v-html="ruleForm.cdgnbzms"></div>
          </div>
        </el-main>
      </el-container>
      <el-empty class="hp100" v-else />
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({})

const loading = ref(false)
const initInfo = () => {
  loading.value = true
  loadData({
    url: '/api/v2/sys/zixitongcaidanmokuaibangzhu/zixitongcaidanmokuaibangzhu/' + sessionStorage.getItem('menuId'),
    ruleForm,
    loadSuccess: function (res) {
      ruleForm.value = res.data || {}
      loading.value = false
    }
  })
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      initInfo()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.card-header {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
